<template>
  <div id="content-wrap" class="content-wrapper">
    <section class="content">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <va-box theme="box-primary" title="Tuỳ chỉnh hệ thống">
          <div slot="content">
            <div class="container-fluid">
              <div class="row">
                <VAInfoBox v-for="(item, idx) in menuItems"
                           class="col-md-3 col-sm-6 col-xs-12"
                           bg-color="bg-active"
                           :bg-icon="item.iconClass"
                           :title="item.title"
                           :subtitle="item.subTitle"
                           :link="item.link"
                           :key="idx" />
              </div>
            </div>
          </div>
        </va-box>
      </div>
    </section>
  </div>
</template>

<script>
import VABox from 'va/widgets/VABox.vue'
import VAInfoBox from '../../components/VAInfoBox'

export default {
  name: 'PhoneNumberSetting',
  data () {
    return {
      menuItems: [
        {
          title: 'Quản lý số chủ',
          iconClass: 'fa fa-phone',
          subTitle: 'Quản lý số chủ',
          link: '/phone-number/main-phone-number',
        },
        {
          title: 'Quản lý số khách',
          iconClass: 'fa fa-mobile',
          subTitle: 'Quản lý khách',
          link: '/phone-number/phone-number-client',
        },
        {
          title: 'Quản lý nhà cung cấp',
          iconClass: 'fa fa-signal',
          subTitle: 'Quản lý nhà cung cấp',
          link: '/phone-number/provider',
        },
        {
          title: 'Quản lý pháp nhân',
          iconClass: 'fa fa-user',
          subTitle: 'Quản lý pháp nhân',
          link: '/phone-number/legal',
        },
        {
          title: 'Quản lý trạng thái số',
          iconClass: 'fa fa-wifi',
          subTitle: 'Quản lý trạng thái số',
          link: '/phone-number/status',
        }
      ]
    }
  },
  components: {
    'va-box': VABox,
    VAInfoBox,
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/phone_number/PhoneNumberSettings.vue